module.exports = __webpack_public_path__ + "media/assets/BigTwirl-886249a18cbff234f884a08ce3461b68.svg";